/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveCryptoPoolRegistryFetcher,
  CurveCryptoPoolRegistryFetcherInterface,
} from "../CurveCryptoPoolRegistryFetcher";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "_addressProvider",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptyAddressProvider",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistryIsTheSame",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "enum RegistryId",
        name: "id",
        type: "uint8",
      },
    ],
    name: "RegistryNotFoundById",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ICurveAddressProviderLike",
        name: "curveAddressProvider",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum RegistryId",
        name: "registryId",
        type: "uint8",
      },
    ],
    name: "DataFetcherCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "RegistryUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "ADDRESS_PROVIDER",
    outputs: [
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_NUMBER_OF_COINS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REGISTRY_ID",
    outputs: [
      {
        internalType: "enum RegistryId",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "curveLPTokensDetailsFetcherPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "getLPTokenDetails",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isMeta",
                type: "bool",
              },
            ],
            internalType: "struct Pool",
            name: "pool",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "coins",
            type: "address[]",
          },
        ],
        internalType: "struct LPTokenDetails",
        name: "details",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveCryptoPoolRegistryFetcherConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveCryptoPoolRegistryFetcherConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveCryptoPoolRegistryFetcher__factory extends ContractFactory {
  constructor(...args: CurveCryptoPoolRegistryFetcherConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveCryptoPoolRegistryFetcher";
  }

  deploy(
    _repository: string,
    _addressProvider: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveCryptoPoolRegistryFetcher> {
    return super.deploy(
      _repository,
      _addressProvider,
      overrides || {}
    ) as Promise<CurveCryptoPoolRegistryFetcher>;
  }
  getDeployTransaction(
    _repository: string,
    _addressProvider: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _repository,
      _addressProvider,
      overrides || {}
    );
  }
  attach(address: string): CurveCryptoPoolRegistryFetcher {
    return super.attach(address) as CurveCryptoPoolRegistryFetcher;
  }
  connect(signer: Signer): CurveCryptoPoolRegistryFetcher__factory {
    return super.connect(signer) as CurveCryptoPoolRegistryFetcher__factory;
  }
  static readonly contractName: "CurveCryptoPoolRegistryFetcher";
  public readonly contractName: "CurveCryptoPoolRegistryFetcher";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveCryptoPoolRegistryFetcherInterface {
    return new utils.Interface(_abi) as CurveCryptoPoolRegistryFetcherInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveCryptoPoolRegistryFetcher {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveCryptoPoolRegistryFetcher;
  }
}
